import { LoanEditorActionsEnum } from 'constants/loanActionEditor';

import { LoanEditorItemInitialValueByType } from '../LoanActionsGroup.utils';

export const OPERATION_LABEL = 'Operation';

// The kind select before an operation is chosen, when there is nothing to choose from yet.
export const NO_OPERATION_KIND_LABEL = 'Type';
export const NO_OPERATION_KIND_OPTIONS = [];

// A new operation starts over: no kind, and its switches at their defaults (not pre-closing; a transfer is flow).
export const PREVIEW_ROW_DEFAULTS =
  LoanEditorItemInitialValueByType[LoanEditorActionsEnum.PREVIEW_MERS];
